import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

export function ShoppingItemDialog({
  open,
  onOpenChange,
  formData,
  setFormData,
  onSubmit,
  isEditing,
  categories,
  members,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white font-['Outfit']">
            {isEditing ? "Edit Item" : "Add Shopping Item"}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-sm text-slate-400 mb-1 block">
              Item Name
            </label>
            <Input
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              placeholder="What do you need?"
              className="bg-slate-950 border-slate-800"
              data-testid="item-name-input"
              autoFocus
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-slate-400 mb-1 block">
                Quantity
              </label>
              <Input
                value={formData.quantity}
                onChange={(e) =>
                  setFormData({ ...formData, quantity: e.target.value })
                }
                placeholder="e.g., 2 lbs, 1 gallon"
                className="bg-slate-950 border-slate-800"
                data-testid="item-quantity-input"
              />
            </div>

            <div>
              <label className="text-sm text-slate-400 mb-1 block">
                Category
              </label>
              <Select
                value={formData.category}
                onValueChange={(val) =>
                  setFormData({ ...formData, category: val })
                }
              >
                <SelectTrigger
                  className="bg-slate-950 border-slate-800"
                  data-testid="item-category-select"
                >
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {categories.map((cat) => (
                    <SelectItem key={cat.id} value={cat.name}>
                      <div className="flex items-center gap-2">
                        <div
                          className="w-2 h-2 rounded-full"
                          style={{ backgroundColor: cat.color }}
                        />
                        {cat.name}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div>
            <label className="text-sm text-slate-400 mb-1 block">
              Assign To (optional)
            </label>
            <Select
              value={formData.assigned_to || "unassigned"}
              onValueChange={(val) =>
                setFormData({
                  ...formData,
                  assigned_to: val === "unassigned" ? "" : val,
                })
              }
            >
              <SelectTrigger
                className="bg-slate-950 border-slate-800"
                data-testid="item-assignee-select"
              >
                <SelectValue placeholder="Who will pick this up?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="unassigned">Anyone</SelectItem>
                {members.map((member) => (
                  <SelectItem key={member.id} value={member.id}>
                    {member.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-slate-700"
              data-testid="item-cancel-button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1 bg-indigo-600 hover:bg-indigo-500"
              data-testid="item-submit-button"
            >
              {isEditing ? "Save Changes" : "Add Item"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
